module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mobile-navigation"
  }, [_c('q-layout-header', {
    attrs: {
      "id": "mobile-navigation"
    }
  }, [_c('q-toolbar', {
    staticClass: "navigation",
    attrs: {
      "color": "brand"
    }
  }, [_c('router-link', {
    staticClass: "logo",
    attrs: {
      "to": {
        name: 'projects'
      }
    }
  }, [_c('logo')], 1), _vm._v(" "), (_vm.compressed) ? _c('div', {
    staticClass: "navigation--compressed"
  }, [_c('div', {
    staticClass: "right-align"
  }, [(_vm.compressedUnpublishedChanges > 0) ? _c('div', {
    staticClass: "unpublished-changes"
  }, [_vm._v("\n            " + _vm._s(_vm.$t("ui.drag_editor.unpublished_changes")) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('add-button')], 1)]) : _vm._e(), _vm._v(" "), _c('q-btn', {
    attrs: {
      "flat": "",
      "round": "",
      "dense": "",
      "icon": "menu"
    },
    on: {
      "click": function($event) {
        _vm.drawer = !_vm.drawer
      }
    }
  })], 1)], 1), _vm._v(" "), _c('q-layout-drawer', {
    attrs: {
      "side": "right",
      "content-style": {
        fontSize: '16px',
        backgroundColor: '#212736'
      }
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('q-list-header', [_c('router-link', {
    staticClass: "logo",
    attrs: {
      "to": {
        name: 'projects'
      }
    }
  }, [_c('logo')], 1)], 1), _vm._v(" "), _c('q-tabs', {
    attrs: {
      "color": "brand"
    }
  }, [_vm._l((_vm.mobileNavigation), function(routes) {
    return _c("authenticated-navigation-item", {
      directives: [{
        name: "can",
        rawName: "v-can",
        value: (routes.credential),
        expression: "routes.credential"
      }],
      key: routes.label,
      tag: "q-route-tab",
      attrs: {
        "slot": "title",
        "exact": "",
        "bindings": _vm.getBindings(routes),
        "auth": routes.auth,
        "label": routes.label
      },
      on: {
        "close": function($event) {
          return _vm.close()
        }
      },
      nativeOn: {
        "click": function($event) {
          return _vm.onClick()
        }
      },
      slot: "title"
    })
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.businessKitLink(),
      "target": "_blank"
    }
  }, [_c('q-tab', [_vm._v("Businesskits")])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('q-route-tab', {
    attrs: {
      "to": {
        name: 'user_profile',
        params: {
          id: _vm.userId
        }
      },
      "label": _vm.$t('ui.menu.profile')
    }
  })], 2), _vm._v(" "), (_vm.userId) ? _c('q-tabs', {
    attrs: {
      "color": "brand"
    }
  }, [_vm._l((_vm.account), function(routes) {
    return _c("authenticated-navigation-item", {
      directives: [{
        name: "can",
        rawName: "v-can",
        value: (routes.credential),
        expression: "routes.credential"
      }],
      key: routes.label,
      tag: "q-route-tab",
      attrs: {
        "slot": "title",
        "exact": "",
        "bindings": _vm.getBindings(routes),
        "auth": routes.auth,
        "label": routes.label
      },
      slot: "title"
    })
  }), _vm._v(" "), _c('q-tab', [_c('language-switcher')], 1)], 2) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cd77954e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/partials/MobileNavigation.vue
// module id = 1995
// module chunks = 0